module.exports = __webpack_public_path__ + "img/empty-temp-introduce-2.df9a59c2.jpg";